import jwt_decode from "jwt-decode";

const getRuntimeNumber = (key, buildTimeValue, fallback) => {
  const runtimeValue =
    typeof window !== "undefined" ? window.__RUNTIME_CONFIG__?.[key] : undefined;
  const parsed = Number(runtimeValue ?? buildTimeValue);

  return Number.isFinite(parsed) && parsed >= 0 ? parsed : fallback;
};

export const ACCESS_TOKEN_REFRESH_MARGIN_SECONDS = getRuntimeNumber(
  "PUBLIC__ACCESS_TOKEN_REFRESH_MARGIN_SECONDS",
  process.env.REACT_APP_ACCESS_TOKEN_REFRESH_MARGIN_SECONDS,
  60
);

export const getTokenExpiration = (token) => {
  if (!token) return null;

  try {
    const expiration = Number(jwt_decode(token)?.exp);
    return Number.isFinite(expiration) ? expiration : null;
  } catch (error) {
    return null;
  }
};

export const getTokenRemainingSeconds = (
  token,
  nowSeconds = Date.now() / 1000
) => {
  const expiration = getTokenExpiration(token);
  return expiration == null ? Number.NEGATIVE_INFINITY : expiration - nowSeconds;
};

export const isTokenValid = (token, nowSeconds = Date.now() / 1000) =>
  getTokenRemainingSeconds(token, nowSeconds) > 0;

export const shouldRefreshAccessToken = (
  token,
  marginSeconds = ACCESS_TOKEN_REFRESH_MARGIN_SECONDS,
  nowSeconds = Date.now() / 1000
) => getTokenRemainingSeconds(token, nowSeconds) <= marginSeconds;
